// Our team's Amigo log (D8). Wording from the Amigo design's copy sheet (Amigo log, Amigo log couldn't do, Amigo log no
// results, Row status); FoodAmigos only, so always Amigo, never the assistant.
export default {
  title: 'Amigo log',
  intro:
    'Every request Amigo handled: what was asked, where, who asked and who approved. Only FoodAmigos sees this page.',
  // The tab list's name for screen readers.
  tabs_label: 'Amigo log',
  tabs: {
    requests: 'Requests',
    gaps: "Couldn't do",
  },
  filters: {
    restaurant: 'Restaurant',
    all_restaurants: 'All restaurants',
    brand: '{{name}} · Brand',
    restaurant_unknown: 'Restaurant {{id}}',
    searching: 'Looking for restaurants…',
    no_restaurant: 'No restaurant called “{{query}}”',
    period: 'Period',
    start_date: 'Start date',
    end_date: 'End date',
    refresh: 'Refresh',
    gap: 'Asked for: {{request}}',
    change_set: 'The request behind one change',
    remove: 'Remove the filter: {{label}}',
    clear: 'Clear filters',
  },
  columns: {
    steps: 'Steps',
    when: 'When',
    request: 'Request',
    restaurant: 'Restaurant',
    asked_by: 'Asked by',
    result: 'Result',
  },
  show_steps: 'Show the steps of: {{request}}',
  approved_by: 'Approved by {{name}}',
  nothing_approved: 'Nothing approved',
  results: {
    applied: '{{applied}} applied',
    applied_skipped: '{{applied}} applied · {{skipped}} skipped',
    partial: '{{applied}} of {{total}} applied',
    imported: 'Imported',
    importing: 'Importing',
    waiting: 'Waiting for approval',
    rejected: 'Rejected',
    undone: 'Undone',
    partly_undone: '{{undone}} of {{total}} undone',
    expired: 'Expired',
    replaced: 'Replaced',
    failed: 'Failed',
    answered: 'Answered',
    not_yet: "Couldn't do yet",
    off_limits: 'Off limits',
    not_allowed: 'Not allowed',
    switched_off: 'Switched off',
    guard: 'Stopped by a safety check',
    not_found: 'Not found',
  },
  steps: {
    asked: '{{name}} asked',
    asked_anonymous: 'Asked',
    approved: 'Approved by {{name}}',
    approved_alone: 'Approved',
    applied_one: 'Applied {{count}} change',
    applied_other: 'Applied {{count}} changes',
    failed_one: '{{count}} not applied',
    failed_other: '{{count}} not applied',
    rejected: 'Rejected',
    undone: 'Undone',
    undone_by: 'Undone, approved by {{name}}',
    skipped_one: '{{count}} skipped',
    skipped_other: '{{count}} skipped',
    skipped_state: 'Skipped',
    more_one: 'and {{count}} more',
    more_other: 'and {{count}} more',
    changes_one: '{{count}} change',
    changes_other: '{{count}} changes',
    other: 'Checking something',
  },
  // The line over a request's steps (QA49): how many, how many shop refused, how many failed.
  summary: {
    steps_one: '{{count}} step',
    steps_other: '{{count}} steps',
    refused_one: '{{count}} refused',
    refused_other: '{{count}} refused',
    failed_one: '{{count}} failed',
    failed_other: '{{count}} failed',
  },
  // A request that changed nothing says what came of it, under Result (design: Log · steps open).
  outcomes: {
    title: 'Result',
    answered: 'An answer: nothing changed.',
    waiting: 'Waiting for approval. Nothing changed yet.',
    rejected: 'Rejected: nothing changed.',
    expired: 'Expired without an approval: nothing changed.',
    replaced: 'Replaced by a newer card: nothing changed here.',
    undone: 'Undone: the changes were taken back.',
    partly_undone: 'Partly undone: {{undone}} of {{total}} changes were taken back.',
    failed: 'Failed: nothing changed.',
    not_yet: "Couldn't do yet: nothing changed. Counted in Couldn't do.",
    off_limits: 'Off limits: nothing changed.',
    not_allowed: "Not allowed for this person's role: nothing changed.",
    switched_off: 'Switched off here: nothing changed.',
    guard: 'Stopped by a safety check: nothing changed.',
    not_found: 'Not found: nothing changed.',
    importing: 'Importing. Each dish goes into Menu → Edit history.',
    imported: 'Imported. Each dish is in Menu → Edit history.',
  },
  changes: {
    // With where they were made: "3 changes · Hilltop Burger · Ehrenfeld".
    where: '{{changes}} · {{where}}',
    title_one: '{{count}} change',
    title_other: '{{count}} changes',
    show_all: 'Show all {{count}} changes',
    show_fewer: 'Show fewer',
    from: 'from',
    to: 'to',
    removed: 'Removed',
  },
  row_states: {
    skipped: 'Skipped',
    failed: 'Not applied',
    stale: 'Changed in the meantime',
    kept: 'Left as it is',
  },
  menu_history: 'Open Menu → Edit history',
  // Opens the request's chat in the Amigo panel, on its restaurant (read only when someone else started it).
  open_chat: 'Open the chat',
  // Both links first switch the dashboard to the request's restaurant; this says that didn't work.
  switch_failed: "Couldn't open that restaurant. Try again.",
  pagination: {
    label: 'Pages',
    summary: '{{from}}–{{to}} of {{total}} requests',
    previous: 'Previous page',
    next: 'Next page',
  },
  empty: {
    title: 'No requests for {{restaurant}} in this period',
    text: "Amigo hasn't handled anything there between {{from}} and {{to}}.",
    title_any_day: 'No requests for {{restaurant}} yet',
    text_any_day: "Amigo hasn't handled anything there yet.",
    title_everywhere: 'No requests in this period',
    text_everywhere: "Amigo hasn't handled anything between {{from}} and {{to}}.",
    title_nothing: 'No requests yet',
    text_nothing: "Amigo hasn't handled anything yet.",
  },
  loading: 'Loading…',
  error: {
    title: "The log couldn't be loaded",
    text: 'Try again in a moment.',
    retry: 'Try again',
  },
  gaps: {
    intro:
      "What Amigo couldn't do yet, grouped by what was asked, most asked first. Off-limits requests and requests a role doesn't allow aren't here.",
    columns: {
      area: 'Area',
      request: 'What people asked for',
      count: 'Asked',
      last_at: 'Last asked',
      requests: 'Requests',
    },
    count: '{{count}}×',
    see_requests_one: 'See {{count}} request',
    see_requests_other: 'See {{count}} requests',
    today: 'Today, {{time}}',
    yesterday: 'Yesterday, {{time}}',
    empty_title: "No requests Amigo couldn't do",
    empty_text: 'Everything people asked for, Amigo could do.',
  },
  areas: {
    menu: 'Menu',
    hours: 'Opening hours',
    order_settings: 'Order settings',
    my_info: 'My info',
    marketing: 'Marketing',
    gift_cards: 'Gift cards',
    reports: 'Reports',
    website: 'Website',
    integrations: 'Integrations',
    delivery: 'Delivery',
    payments: 'Payments',
    team: 'Team',
    billing: 'Billing',
    settings: 'Settings',
    other: 'Other',
  },
};
